"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var geometry_1 = require("../geometry");
function parseGeometry(value) {
    if (value === "auto") {
        return geometry_1.GeometryValue.auto;
    }
    if (typeof value !== "string") {
        return { value: 0, unit: geometry_1.GeometryUnit.Pixel, offset: 0 };
    }
    if (value.match(/^-?[\d\.]+$/)) {
        // is a number
        return { value: parseFloat(value), unit: geometry_1.GeometryUnit.Pixel, offset: 0 };
    }
    var matches = value.match(/^(-?\d+(\.\d+)?)%( ?[+|-] ?\d+(\.\d+)?)?$/);
    if (matches === null) {
        throw new Error("Geometry value " + value + " has wrong format");
    }
    return {
        value: parseFloat(matches[1]),
        unit: geometry_1.GeometryUnit.Percent,
        offset: matches[3] ? parseFloat(matches[3]) : 0,
    };
}
exports.parseGeometry = parseGeometry;
function parseNumberWithAuto(value) {
    if (value === "auto") {
        return -1;
    }
    return parseFloat(value);
}
exports.parseNumberWithAuto = parseNumberWithAuto;
function parseFunc(value) {
    return new Function("return " + value).call(null);
}
exports.parseFunc = parseFunc;
function parseJSON(value) {
    return JSON.parse(value);
}
exports.parseJSON = parseJSON;
/** @function parsePadding
 * Used in @class hierarchy-layout
 * For parsing the padding option that could be a number, a number array or a function that outputs a number
 */
function parsePadding(value) {
    if (value.indexOf(",") !== -1) {
        return parseJSON(value);
    }
    else {
        var tryFloat = parseFloat(value);
        if (isNaN(tryFloat)) {
            return parseFunc(value);
        }
        else {
            return tryFloat;
        }
    }
}
exports.parsePadding = parsePadding;
function parseBoolean(value) {
    return value === "true";
}
exports.parseBoolean = parseBoolean;
function parseNumberOrFunc(value) {
    var tryNum = parseNumberWithAuto(value);
    return isNaN(tryNum) ? parseFunc(value) : tryNum;
}
exports.parseNumberOrFunc = parseNumberOrFunc;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/template/utils.js
// module id = 17
// module chunks = 0 1